import { computed, Injectable, signal, Signal, WritableSignal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private _loadingDict: Record<string, { stack: unknown[]; status: WritableSignal<boolean> }> = {};

  isLoading(key: string): Signal<boolean> {
    this.setDictionary(key);
    return this._loadingDict[key].status.asReadonly();
  }

  isLoadingMultiple(...keys: string[]): Signal<boolean> {
    return computed(() => keys.map(k => this.isLoading(k)()).some(Boolean));
  }

  pushLoading<T = unknown>(key: string, value?: T): void {
    this.setDictionary(key);
    this._loadingDict[key].stack.push(value);
    if (!this._loadingDict[key].status() && this._loadingDict[key].stack.length > 0) {
      this._loadingDict[key].status.set(true);
    }
  }

  popLoading<T = unknown>(key: string, value?: T): T | null {
    this.setDictionary(key);
    let popped: T | null = null;
    if (!value) {
      popped = this._loadingDict[key].stack.pop() as T;
    } else {
      const idx = this._loadingDict[key].stack.indexOf(value);
      if (idx > -1) popped = this._loadingDict[key].stack.splice(idx, 1)[0] as T;
    }
    if (this._loadingDict[key].status() && this._loadingDict[key].stack.length === 0) {
      this._loadingDict[key].status.set(false);
    }
    return popped;
  }

  private setDictionary(key: string): void {
    if (!this._loadingDict[key]) {
      this._loadingDict[key] = { stack: [], status: signal(false) };
    }
  }
}
